document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".product_form");
  if(productForm){
  const submitButton = productForm.querySelector(".bulk-add-to-cart-button");
  const submitMessageElement = productForm.querySelector(".form-submission-message");
  const originalButtonText = submitButton.innerHTML;
  const spinnerHTML = '<div class="spinner"></div>';
  const cartCountElements = document.querySelectorAll("cart-count");

  const quantityInputs = document.querySelectorAll(".bulk-quantity-selector");

  function updateSubmitButtonState() {
    let hasValidQuantity = false;

    quantityInputs.forEach(function (input) {
      if (parseInt(input.value) > 0) {
        hasValidQuantity = true;
      }
    });

    if (hasValidQuantity) {
      submitButton.disabled = false;
      submitButton.innerHTML = originalButtonText;
    } else {
      submitButton.disabled = true;
      submitButton.innerHTML = "Select at least 1 variant";
    }
  }

  quantityInputs.forEach(function (input) {
    input.addEventListener("change", function (event) {
      const max = parseInt(input.getAttribute("max"));
      const value = parseInt(input.value);
      const variantId = input.id.match(/\d+/)[0];
      const hiddenInput = document.querySelector(`input[type="hidden"][value="${variantId}"]`);

      if (value > max) {
        input.value = max;
      }

      if (input.value > 0) {
        hiddenInput.setAttribute("selected", "selected");
      } else {
        hiddenInput.removeAttribute("selected");
      }

      updateSubmitButtonState();
    });
  });

  updateSubmitButtonState();

  productForm.addEventListener("submit", function (event) {
    event.preventDefault();

    let submitMessage = "Added item(s) to the cart.";
    let submitMessageClass = "form-submission-message--success";

    submitButton.disabled = true;
    submitButton.innerHTML = spinnerHTML;

    const selectedVariants = [];

    document.querySelectorAll('input[type="hidden"][selected="selected"]').forEach(function (hiddenInput) {
      const variantId = hiddenInput.value;
      const quantityInput = document.querySelector(`#quantity_${variantId}`);
      const quantity = parseInt(quantityInput.value);

      if (quantity > 0) {
        selectedVariants.push({ id: variantId, quantity: quantity });
      }
    });

    if (selectedVariants.length === 0) {
      alert("Please select at least one variant.");
      submitButton.disabled = false;
      submitButton.innerHTML = originalButtonText;
      return;
    }

    const requestData = {
      items: selectedVariants.map((variant) => {
        return {
          id: variant.id,
          quantity: variant.quantity
        };
      })
    };

    console.log("Request data:", requestData);

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;"
      },
      body: JSON.stringify(requestData)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart update response:", data);

        if (data.status == 422) {
          submitMessage = data.message + " - " + data.description;
          submitMessageClass = "form-submission-message--error";
        } else {
          fetch("/cart.js", {
            method: "GET",
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          })
            .then((response) => response.json())
            .then((cartData) => {
              cartCountElements.forEach(cartCountElement => {
                cartCountElement.innerHTML = cartData.item_count;
                cartCountElement.setAttribute('data-cart-count', cartData.item_count);
              });
            })
            .catch((error) => {
              console.error("Error fetching cart data:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error adding items to cart:", error);
        submitMessage = "Could not add selected item(s) to the cart because of an error.";
        submitMessageClass = "form-submission-message--error";
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonText;
        submitMessageElement.classList.add(submitMessageClass);
        submitMessageElement.innerHTML = submitMessage;

        setTimeout(() => {
          submitMessageElement.innerHTML = "";
          submitMessageElement.classList.remove(submitMessageClass);
        }, 5000);

        quantityInputs.forEach(function (input) {
          input.value = "0";
          input.dispatchEvent(new Event("change")); // Trigger the change event to update hidden fields
        });

        // Update the submit button state after resetting the inputs
        updateSubmitButtonState();
      });
  });  
  }
});


